import { get, post, put, deleteApi } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";
import { OppoUtils } from "../../utils";

const { APIS } = API_ENDPOINTS;

export const fetchAllOpportunities = filters => {
  const url = filters
    ? OppoUtils.prepareFilteredOpportunitiesUrl(filters, APIS.OPPORTUNITIES_V3)
    : APIS.OPPORTUNITIES_V3;
  return new Promise((resolve, reject) => {
    get(`${url}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => fetchAllOpportunities => ${error}`);
        reject(error);
      });
  });
};

export const fetchAllUsers = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.USERS}?mailNameContains=`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => fetchAllUsers => ${error}`);
        reject(error);
      });
  });

export const searchUser = searchedContent =>
  new Promise((resolve, reject) => {
    get(`${APIS.USERS}?mailNameContains=${searchedContent}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => fetchAllUsers => ${error}`);
        reject(error);
      });
  });

export const fetchAllAccounts = () =>
  new Promise((resolve, reject) => {
    get(APIS.ACCOUNTS_V2)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => fetchAllAccounts => ${error}`);
        reject(error);
      });
  });

export const fetchAllOpportunitiesByAccount = accountID =>
  new Promise((resolve, reject) => {
    get(`${APIS.OPPORTUNITIES}?account=${accountID}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(
          `pipelineServices => fetchAllOpportunitiesByAccount => ${error}`,
        );
        reject(error);
      });
  });

export const fetchOpportunityByID = oppID =>
  new Promise((resolve, reject) => {
    get(`${APIS.OPPORTUNITIES}/${oppID}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => fetchOpportunityByID => ${error}`);
        reject(error);
      });
  });

export const fetchAllOpportunityStages = () =>
  new Promise((resolve, reject) => {
    get(APIS.OPPORTUNITY_STAGES)
      .then(res => {
        resolve(res.Stages);
      })
      .catch(error => {
        console.error(
          `pipelineServices => fetchAllOpportunityStages => ${error}`,
        );
        reject(error);
      });
  });

export const getAllPricebooksService = () =>
  new Promise((resolve, reject) => {
    get(APIS.PRICE_LISTS)
      .then(res => {
        resolve(res.PriceListPage.plists);
      })
      .catch(error => {
        console.error(
          `pipelineServices => getAllPricebooksService => ${error}`,
        );
        reject(error);
      });
  });

export const createOpportunityService = payload =>
  new Promise((resolve, reject) => {
    post(APIS.OPPORTUNITIES_V2, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const createAccountService = payload =>
  new Promise((resolve, reject) => {
    post(APIS.ACCOUNTS, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const shareOppoService = payload =>
  new Promise((resolve, reject) => {
    post(APIS.ACCESS_CONTROLS, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const patchOppoAccessService = payload =>
  new Promise((resolve, reject) => {
    put(APIS.ACCESS_CONTROLS, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchOppoAccessService = oppoID =>
  new Promise((resolve, reject) => {
    get(`${APIS.ACCESS_CONTROLS}/${oppoID}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteOppoAccessService = hash =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.ACCESS_CONTROLS}?share_hash=${hash}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/PipelineActions/pipelineServices.js